import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";
import { getLanguage } from "@/utils/languageUtils";
import { leadUILabels } from "@/i18n";

interface DuplicateVehicleCardDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onMarkAsCompleted: () => void;
  regNumber: string;
  existingVehicleCardId: string;
}

export const DuplicateVehicleCardDialog = ({
  isOpen,
  onClose,
  onMarkAsCompleted,
  regNumber,
  existingVehicleCardId,
}: DuplicateVehicleCardDialogProps) => {
  const uiLabels = leadUILabels(getLanguage());
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500" />
            <DialogTitle>{uiLabels.duplicateDialogTitle}</DialogTitle>
          </div>
          <DialogDescription className="text-left">
            {uiLabels.duplicateDialogDescription}{" "}
            <span className="font-semibold">{regNumber}</span>.
            <br />
            <br />
            {uiLabels.duplicateDialogExistingId}{" "}
            <span className="font-mono text-sm">{existingVehicleCardId}</span>
            <br />
            <br />
            {uiLabels.duplicateDialogQuestion}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={onClose}>
            {uiLabels.duplicateDialogNo}
          </Button>
          <Button
            onClick={onMarkAsCompleted}
            className="bg-green-600 hover:bg-green-700"
          >
            {uiLabels.duplicateDialogYesMarkCompleted}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
